<template>
    <div style="height:100%">
        <iframe style="width:100%;height:100%;border:0;" src="https://new-wx.ylyk.com/static/userAgreement.html"></iframe>
    </div>
</template>

<script>
// 商品订单的成功页面
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import PayUser from './components/pay-user'
import { appUser } from '@/utils'

export default {
  name: 'yhxy',
  components: { PayUser },
  mixins: [Body],
  data() {
    return {
      title: ''
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'payStatus' // 支付状态
    ]),
    ...mapGetters('goods/vip', [
      'isNeedAuthentic'
    ]),
    to() {
      return { name: 'confirmOrder' }
    },
    goodsId() {
    }
  },
  activated() {
    
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.pay-success {
  background: 
    url("../../../images/payment/success_BG_ellipse_left.png") no-repeat,
    url("../../../images/payment/success_BG_ellipse_right.png") no-repeat,
    url("../../../images/payment/success_BG.png") no-repeat;
  background-color: #f7f9fb;
  background-size: 52px 79px, 65px 100px, 100% 40%;
  background-position-x: left, right, center;
  background-position-y: 22%, 7%, top;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  // 支付状态
  .pay-status {
    font-size: 18px;
    font-weight: bold;
    margin: 20px 0 40px 0;
    color: white;
    text-align: center;
    .img-success {
      display: inline-block;
      width: 48px;
      height: 48px;
      border:1px solid rgba(255,255,255,1);
      border-radius: 50%;
      margin-bottom: 20px;
      background: url("../../../images/payment/icon_choose_large_def.png") no-repeat;
      background-size: 20px;
      background-position: center;
    }
    // 课程引导
    .course-text {
      .course-success {
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        opacity: 1;
      }
      // 进入书桌
      .desk {
        margin-top: 10px;
        height:17px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,0.8);
        line-height:17px;
      }
    }
  }
}
</style>
